<template>
    <div class="instructor-schedule-container">
        <PreLoader v-if="isLoading"/>
        <div class="schedule-content">
            <div class="titleSchedule">{{$t('schedule')}}</div>
            <v-btn-toggle v-model="toggle_exclusive" tile group style="color: #2F80ED">
                <v-btn dense outlined v-for="item in childrenData" :key="item.id"
                       style="padding: 30px 10px; border-radius: 8px" @click="getScheduleByChildren(item.studentId)">
                    <div style="display: flex; flex-direction: column">
                        <div>{{item.studentName}} {{item.studentSurname}}</div>
                    </div>
                </v-btn>
            </v-btn-toggle>
            <div>
                <v-btn-toggle v-model="text" tile group style="color: #2F80ED">
                    <v-btn @click="getScheduleByDate(item.date)" v-for="(item) in days" :key="item.day"
                           :value="item.name" style="padding: 30px 10px; border-radius: 8px">
                        <div style="display: flex; flex-direction: column; gap: 8px;">
                            <div>{{item.name}}</div>
                            <div>{{item.date}}</div>
                        </div>
                    </v-btn>
                </v-btn-toggle>
                <div v-if="!items.length" v-show="isShow" class="txt-no-data">{{$t('noLesson')}}</div>
                <v-card v-else width="max-content" max-width="600px" class="card-st">
                    <v-list>
                        <template v-for="(item, index) in items">
                            <v-list-item :key="index">
                                <v-list-item-content>
                                    <v-list-item class="content-item-block">
                                        <span class="lesson-title">{{item.startTime}}</span>
                                        <div class="block-info">
                                            <span class="lesson-title">{{item.courseTitle}}</span>
                                            <span >{{$t('teacher')}}: {{item.instructorFullName}}</span>
                                            <span>{{$t('topic')}}: {{item.topicTitle}}</span>
                                            <span>{{$t('mark')}}:
                                            <span v-html="absents.find(el => el.code === item.mark + '') ? absents
                                            .find(el => el.code === item.mark + '').title : item.mark"/>
                                        </span>
                                        </div>
                                    </v-list-item>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider v-if="index < items.length - 1"/>
                        </template>
                    </v-list>
                </v-card>
            </div>
        </div>
    </div>
</template>

<script>

import moment from 'moment/moment'
import StudentDataService from '@/_services/student-data.service'
import PreLoader from '@/components/preloader/PreLoader.vue'
import ParentService from '@/_services/parent.service'

export default {
  name: 'WeekSchedule',
  components: { PreLoader },
  created () {
    this.isLoading = true
    this.isShow = false
    this.setCurrentDates()
    this.getChildren()
    const date = new Date()
    this.todayDate = moment(new Date(date.setDate(date.getDate())))
      .format('DD-MM-YYYY')
    this.text = this.days.find(el => el.date === moment(new Date(date.setDate(date.getDate())))
      .format('DD.MM.YYYY')).name
  },
  data () {
    return {
      absents: [
        { title: this.$t('respectfulAbsence'), code: '92' },
        { title: this.$t('respectfulThink'), code: '93' },
        { title: this.$t('disrespectfulAbsense'), code: '95' }
      ],
      todayDate: '',
      toggle_exclusive: null,
      isShow: false,
      selectedChildren: '',
      text: '',
      childrenData: [],
      items: [],
      langObj: {
        ru: 'courseTitle',
        kg: 'courseTitleKG',
        en: 'courseCode'
      },
      isLoading: false
    }
  },
  computed: {
    userProfile () {
      return this.$store.state.account.profile
    },
    school () {
      return this.userProfile.schools[0]
    },
    currentLang () {
      return this.$root.$i18n.locale
    },
    days () {
      return [
        { day: 1, name: this.$t('mon') },
        { day: 2, name: this.$t('tue') },
        { day: 3, name: this.$t('wed') },
        { day: 4, name: this.$t('thu') },
        { day: 5, name: this.$t('fri') },
        { day: 6, name: this.$t('sat') }
      ]
    }
  },
  mounted () {
    this.absents = [
      { title: this.$t('respectfulAbsence'), code: '92' },
      { title: this.$t('respectfulThink'), code: '93' },
      { title: this.$t('disrespectfulAbsense'), code: '95' }
    ]
  },
  methods: {
    getChildren () {
      ParentService.getAllChildren(this.userProfile.personId).then((res) => {
        this.isLoading = false
        if (res._embedded) {
          this.childrenData = res._embedded.studentParentResourceList
        } else {
          this.childrenData = []
        }
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },
    setCurrentDates () {
      const date = new Date()
      this.days.map((item) => {
        item.date = moment(new Date(date.setDate(date.getDate() - date.getDay() + item.day)))
          .format('DD.MM.YYYY')
        return item
      })
    },
    fetchSchedule () {
      StudentDataService.getStudentSchedule(this.todayDate, this.selectedChildren).then((res) => {
        if (res.length) {
          this.items = res
          for (let i = 0; i < this.items.length; i++) {
            this.items[i].startTime = res[i].startTime.split(':')[0] + ':' +
                res[i].startTime.split(':')[1]
          }
          this.isShow = true
          this.isLoading = false
        } else {
          this.isLoading = false
          this.items = []
        }
      }).catch((err) => {
        this.$toast.error(this.$t('chooseChild'))
        this.isLoading = false
      })
    },
    getScheduleByChildren (id) {
      this.selectedChildren = id
      this.fetchSchedule()
    },
    getScheduleByDate (date) {
      this.todayDate = date.replaceAll('.', '-')
      this.fetchSchedule()
    }
  }
}
</script>

<style lang="scss" scoped>
.titleSchedule{
    font-size: 30px;
    font-weight: 600;
    padding-bottom: 20px;
}

.txt-no-data{
    padding: 20px;
    font-size: 15px;
    color: #707683
}
.card-st{
    margin-top: 20px; border-radius: 8px;
    .content-item-block{
        display: flex;
        flex-direction: row;
        gap: 20px;
        align-items: flex-start;
    }
    .lesson-title{
        font-weight: 600; font-size: 18px; padding-bottom: 8px; color: black!important;
    }
    .block-info{
        flex-direction: column; display: flex; gap: 8px; color: #707683;
    }
}
.instructor-schedule-container {
    margin: 30px;
    .schedule-content {
        margin-top: 25px;
        display: flex;
        flex-direction: column;
        .select-shift {
            width: 270px;
            margin: 0 auto 25px;
        }
    }
}
th, td {
    vertical-align: middle;
}
</style>
